import XLSX from "sheetjs-style";
import ConvertNumbersToEn from "./ConvertNumbersToEn";

const mobileHeaders = new Set([
  "mobile", "mobiles", "mobilenumber", "phone", "phonenumber", "telephone",
  "شماره", "شمارهها", "موبایل", "شمارهموبایل", "تلفن", "تلفنهمراه",
  "شمارهتلفن", "شمارهتلفنهمراه", "شمارهتماس",
]);

export default async function readMobileNumbersFile(file) {
  const isCsv = /\.csv$/i.test(file.name);
  if (!/\.(csv|xlsx|xls)$/i.test(file.name)) {
    throw new Error("فایل باید CSV یا Excel با پسوند xlsx یا xls باشد.");
  }

  const contents = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("خواندن فایل انجام نشد. دوباره تلاش کنید."));
    reader.onabort = () => reject(new Error("خواندن فایل متوقف شد."));
    if (isCsv) reader.readAsText(file, "UTF-8");
    else reader.readAsArrayBuffer(file);
  });

  let workbook;
  try {
    workbook = XLSX.read(contents, {
      type: isCsv ? "string" : "array",
      raw: true,
    });
  } catch {
    throw new Error("فایل قابل خواندن نیست. یک فایل CSV یا Excel معتبر انتخاب کنید.");
  }

  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  // Start at column A even when the worksheet's used range starts elsewhere.
  const rows = sheet?.["!ref"]
    ? XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        range: {
          s: { r: 0, c: 0 },
          e: { r: XLSX.utils.decode_range(sheet["!ref"]).e.r, c: 0 },
        },
        raw: true,
        blankrows: false,
      })
    : [];
  const numbers = rows
    .map((row) => ConvertNumbersToEn(String(row[0] ?? "")).trim())
    .filter(Boolean);

  const header = numbers[0]?.toLowerCase().replace(/[\s\u200c_-]/g, "");
  if (mobileHeaders.has(header)) numbers.shift();

  if (!numbers.length) {
    throw new Error("ستون اول فایل شماره‌ای ندارد.");
  }

  // Excel numeric cells lose the leading zero of Iranian mobile numbers.
  return numbers.map((number) => /^9\d{9}$/.test(number) ? "0" + number : number);
}
